import React, { useEffect, useState, useMemo } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import PropTypes from "prop-types";

import * as brandActions from "src/redux/actions/brand.action";
import * as departmentActions from "src/redux/actions/department.action";
import * as yearActions from "src/redux/actions/year.action";
import * as reportfinalbybrandActions from "src/redux/actions/reportfinalbybrand.action";
import * as budgetsActions from "src/redux/actions/budgets.action";
import * as approvebudgetActions from "src/redux/actions/approvebudget.action";
import * as updateapprovebudgetActions from "src/redux/actions/updateapprovebudget.action";
import * as rejectapprovebudgetActions from "src/redux/actions/rejectapprovebudget.action";
import * as approvebudgethistoryActions from "src/redux/actions/approvebudgethistory.action";

import { useParams } from "react-router-dom";
import {
  AppBar,
  Tabs,
  Tab,
  TextField,
  Grid,
  Typography,
  makeStyles,
  Button,
  Icon,
  Modal,
  Backdrop,
  Fade,
  Card,
  CardActions,
  CardContent,
  MenuItem,
  Paper,
  Box,
  ButtonGroup,
  Container,
  CardHeader,
  Divider,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
// import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Formik, Form, Field } from "formik";

import { TextField as TextFieldFormik } from "formik-material-ui";
// import budgetssidReducer from "../../reducers/budgetssid.reducer";
import CustomDialog from "src/components/fragments/CustomDialog";
import PopupDialog from "src/components/fragments/PopupDialog";
import Page from "src/components/Page";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  iconbtnreject: {
    color: "secondary",
  },
}));

export default function ManagerReportByBrand() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [brandId, setBrandId] = useState(0);
  const [deptId, setDeptId] = useState(0);
  const [yearId, setYearId] = useState(0);
  const [yearCode, setyearCode] = useState(0);
  const [yearLock, setYearLock] = useState(null);
  const [budgetsid, setBudgetsid] = useState(null);
  const [openPopupDlg, setOpenPopupDlg] = useState(false);
  const [openDlgconfirm, setopenDlgconfirm] = useState(false);
  const [openPopupDlgWarn, setOpenPopupDlgWarn] = useState(false);

  const yearReducer = useSelector(({ yearReducer }) => yearReducer);
  const budgetsReducer = useSelector(
    ({ budgetsReducer }) => budgetsReducer,
    shallowEqual
  );
  const brandReducer = useSelector(({ brandReducer }) => brandReducer);
  const departmentReducer = useSelector((state) => state.departmentReducer);
  const loginReducer = useSelector((state) => state.loginReducer);
  const reportfinalbybrandReducer = useSelector(
    (state) => state.reportfinalbybrandReducer
  );

  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch(
        brandActions.getBrands(
          loginReducer.result.countryid,
          loginReducer.result.companyid,
          loginReducer.result.secureid
        )
      );
      dispatch(
        yearActions.getYear(
          loginReducer.result.countryid +
            loginReducer.result.companyid +
            brandId +
            yearId
        )
      );
      return () => {};
    },
    []
    // [countryid, companyid, brandId, deptId, yearId]
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const clearDataDropDown = () => {
    dispatch(reportfinalbybrandActions.clearreportFianlByBrand());
    dispatch(
      brandActions.getBrands(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid
      )
    );
  };

  const handleChangeYear = (e) => {
    const { BUDGETH_ID, YEAR_CODE, BUDGETH_LOCK } = JSON.parse(e.target.value);
    clearDataDropDown();

    if (BUDGETH_ID !== undefined) {
      setYearId(BUDGETH_ID);
    } else {
      setYearId(0);
    }

    setyearCode(YEAR_CODE);
    setYearLock(BUDGETH_LOCK);
  };

  const handlePopupDlg = (value) => {
    if (value) {
      setOpenPopupDlg(false);
    }
  };

  const handlePopupDlgWarn = (value) => {
    if (value) {
      setOpenPopupDlgWarn(false);
    }
  };

  return (
    <Page className={classes.root} title="Final Budget Report by brand">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For Final Budget Report by Brand"
            title="Final Budget Report by Brand"
          />
          <Divider />
          <CardContent>
            <form>
              <Grid container xs={12}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  flex={1}
                  style={{ lineHeight: 5 }}
                >
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeYear}
                    label="Year"
                    style={{ width: "20%" }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={0}
                  >
                    <option key={0} value={0} selected>
                      -
                    </option>
                    {yearReducer.result &&
                      yearReducer.result.map((item) => (
                        // <MenuItem value={item}>{item.YEAR_CODE}</MenuItem>
                        <option
                          key={item.YEAR_CODE}
                          value={JSON.stringify(item)}
                        >
                          {/* {item.YEAR_CODE} */}
                          {item.YEAR_SEQ_T}
                        </option>
                      ))}
                  </TextField>
                  <Box style={{ marginLeft: 10 }}></Box>
                </Box>
              </Grid>
            </form>
            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant="fullWidth"
                centered
              >
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="Final Budget Report by Brand"
                  {...a11yProps(0)}
                />
              </Tabs>
            </AppBar>

            <TabPanel value={value} index={0}>
              {/* Data */}
              <Grid container spacing={2}>
                <Paper className={classes.root}>
                  <MaterialTable
                    title="Report by Brand"
                    // isLoading={approvebudgetReducer.isFetching}
                    on
                    columns={[
                      {
                        title: "ORG_BRAND_ID",
                        field: "ORG_BRAND_ID",
                        hidden: true,
                      },
                      {
                        title: "Code",
                        field: "REF_CODE",
                        width: 50,
                      },
                      {
                        title: "Brand",
                        field: "BRAND",
                      },
                    ]}
                    data={brandReducer.result ? brandReducer.result : []}
                    actions={[
                      {
                        tooltip: "Send Mail",
                        iconProps: {
                          style: {
                            fontSize: "50px",
                            color: "#5c9aff",

                            captionSide: "bottom",
                          },
                        },
                        icon: "mail",
                        onClick: (e, rowData) => {
                          if (yearId !== 0) {
                            let data = {};
                            data.brand = rowData;
                            data.country_name = loginReducer.result.country;
                            data.company_name = loginReducer.result.company;
                            data.input = {
                              COUNTRYID: loginReducer.result.countryid,
                              COMPANYID: loginReducer.result.companyid,
                              HID: yearId,
                              EMAIL: loginReducer.result.email,
                              YEARCODE: yearCode,
                              SECID: loginReducer.result.secureid,
                            };
                            dispatch(
                              reportfinalbybrandActions.reportFinalByBrand(data)
                            )
                              .then((result) => {
                                setOpenPopupDlg(true);
                              })
                              .catch((result) => {
                                // Error Message
                              });
                            setOpenPopupDlg(true);
                          } else {
                            setOpenPopupDlgWarn(true);
                          }
                        },
                      },
                    ]}
                    options={{
                      selection: true,

                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      showTitle: false,
                      // searchFieldAlignment: "left",
                      pageSize: 10,
                      pageSizeOptions: [10, 50, 100],
                      paging: true,
                    }}
                  />
                </Paper>
              </Grid>
            </TabPanel>
            <PopupDialog
              title="Information Message : Report final By Brand"
              message={
                reportfinalbybrandReducer.isFetching ? (
                  <Alert severity="info">Loading ...</Alert>
                ) : reportfinalbybrandReducer.isError ? (
                  <Alert severity="error">Cannot Send Mail.</Alert>
                ) : (
                  <Alert severity="success">
                    Send E-mail to {loginReducer.result.email} Completed.
                  </Alert>
                )
              }
              disabledBtn={reportfinalbybrandReducer.isFetching ? true : false}
              // disabledBtn={true}
              open={openPopupDlg}
              onClose={handlePopupDlg}
            />
            <PopupDialog
              title="Information Message : Report final By Department"
              message={
                <Alert severity="warning">Please choose year of budget.</Alert>
              }
              open={openPopupDlgWarn}
              onClose={handlePopupDlgWarn}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
